import { createFrontendModule } from '@backstage/frontend-plugin-api'
import { ThemeBlueprint } from '@backstage/plugin-app-react'
import {
  UnifiedThemeProvider,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme'
import { RiMoonLine, RiSunLine } from '@remixicon/react'
import { BRAND } from './brand'

// Material UI side of the app (sidebar, page headers, legacy components).
// Backstage UI tokens live in deepgaming.css and follow data-theme-mode.
const navigation = {
  background: BRAND.plumDeep,
  indicator: BRAND.yellow,
  color: '#e9ddf2',
  selectedColor: BRAND.yellow,
  navItem: { hoverBackground: 'rgba(255, 255, 255, 0.08)' },
  submenu: { background: BRAND.plum },
}

const pageTheme = {
  home: genPageTheme({ colors: [BRAND.plum, '#6a2c8f'], shape: shapes.wave }),
  service: genPageTheme({ colors: [BRAND.plum, '#6a2c8f'], shape: shapes.wave }),
  website: genPageTheme({ colors: ['#5a2378', BRAND.plumSoft], shape: shapes.wave2 }),
  library: genPageTheme({ colors: ['#3b1e52', '#7b4a9e'], shape: shapes.round }),
  documentation: genPageTheme({ colors: [BRAND.plumDeep, '#5a2378'], shape: shapes.wave }),
  tool: genPageTheme({ colors: ['#4d1d6b', BRAND.plumSoft], shape: shapes.round }),
  other: genPageTheme({ colors: [BRAND.plum, '#6a2c8f'], shape: shapes.wave }),
  app: genPageTheme({ colors: [BRAND.plum, '#6a2c8f'], shape: shapes.wave }),
  apis: genPageTheme({ colors: ['#5a2378', BRAND.plumSoft], shape: shapes.wave2 }),
}

const light = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: BRAND.plum },
    secondary: { main: BRAND.yellowDeep },
    background: { default: '#faf8fc', paper: '#ffffff' },
    navigation,
  },
  fontFamily: BRAND.fontSans,
  defaultPageTheme: 'home',
  pageTheme,
})

const dark = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: '#c9a6e3' },
    secondary: { main: BRAND.yellow },
    background: { default: '#15101c', paper: '#1f1727' },
    navigation,
  },
  fontFamily: BRAND.fontSans,
  defaultPageTheme: 'home',
  pageTheme,
})

const lightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'DeepGaming light',
      variant: 'light',
      icon: <RiSunLine size="1em" />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={light} children={children} />
      ),
    },
  },
})

const darkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'DeepGaming dark',
      variant: 'dark',
      icon: <RiMoonLine size="1em" />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={dark} children={children} />
      ),
    },
  },
})

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightTheme, darkTheme],
})
